import { useState } from 'react';
import NewsFeed from './NewsFeed';
import Scout from './Scout';
import ScoutMonitor from './ScoutMonitor';

const tabs = [
  { name: 'Scout Search', key: 'scout' },
  { name: 'Scout Monitor', key: 'scout-monitor' },
  { name: 'News', key: 'news' },
];

export default function DiscoverPage() {
  const [activeTab, setActiveTab] = useState('scout');

  return (
    <div className="p-4 max-w-5xl mx-auto pt-8 lg:pt-12">
      <div className="border-b border-gray-700 mb-6">
        <nav className="-mb-px flex space-x-8">
          {tabs.map((tab) => (
            <button
              key={tab.key}
              onClick={() => setActiveTab(tab.key)}
              className={`pb-2 px-3 text-sm font-medium ${
                activeTab === tab.key
                  ? 'border-b-2 border-purple-500 text-purple-300'
                  : 'text-gray-400 hover:text-gray-200'
              }`}
            >
              {tab.name}
            </button>
          ))}
        </nav>
      </div>

      <div>
        {activeTab === "scout" && <Scout />}
        {activeTab === "scout-monitor" && <ScoutMonitor />}
        {activeTab === 'news' && <NewsFeed />}
      </div>
    </div>
  );
}
